import React from 'react'

const API_KEY = 'adde10516d34a0da0c0f5be106d85be5'

const Fallback = ({ children }: { children: React.ReactElement }) => {
  return children
}

export const ErrorBoundary = Fallback
